<template>
    <div>
        <md-card-content>
            <template>
                <md-table class="paginated-table no-actions" :value="interventions" table-header-color="blue">
                    <md-table-toolbar>
                        <md-field>
                            <label for="pages">Éléments à afficher</label>
                            <md-select v-model="pagination.perPage" id="pages" name="pages">
                                <md-option
                                    v-for="item in pagination.perPageOptions"
                                    :key="item" :label="item" :value="item">
                                    {{ item }}
                                </md-option>
                            </md-select>
                        </md-field>

                        <md-field>
                            <md-input
                                type="search"
                                clearable
                                style="width: 250px"
                                placeholder="Rechercher..."
                                v-model="searchQuery"
                                @keyup="this.getInterventions"
                            >
                            </md-input>
                        </md-field>
                    </md-table-toolbar>

                        <md-table-row v-if="!loading && interventions.length > 0" slot="md-table-row" slot-scope="{ item }" class="text-center">
                            <md-table-cell md-label="Type">
                                <div class="flex flex-col text-center">
                                    <span class="font-medium">{{ getInterventionType(item) }}</span>
                                    <span class="text-xs">{{ item.intervention_type ?  item.intervention_type.name : '' }}</span>
                                </div>
                            </md-table-cell>
                            <md-table-cell md-label="Site">
                                <div>
                                    {{ item.site ? item.site.name : (item.contract ? item.contract.site.name : (item.planning_intervention_prevision.planning_intervention_group.planning_intervention.contract.site.name)) }}
                                </div>
                                <div class="text-info font-medium text-xs">
                                    <span class="cursor-pointer hover:underline" v-if="getContract(item)" @mousedown="goToRoute($event, 'Contract Details', { contractId: getContract(item).id })">
                                        {{ getContract(item).number }}
                                    </span>
                                </div>
                            </md-table-cell>
                            <md-table-cell md-label="Date">
                                <div class="flex flex-col text-center">
                                    <div>
										<span class="text-info font-medium cursor-pointer hover:underline"
											@mousedown="goToRoute($event, 'Calendar', '', {
												month: parseInt($moment(item.start_date).format('M')) - 1, year: $moment(item.start_date).format('YYYY'), technicianId: item.technician.id
											})">
											{{ getStartDate(item.planningable.start_date) }}
										</span>
									</div>
                                    <span class="text-xs">{{ getPlanificationDate(item.planification_date) }}</span>
                                </div>
                            </md-table-cell>
                            <md-table-cell md-label="Planif.">
                                <div class="flex flex-col text-center">
                                    <span>{{ getStartTime(item.planningable.start_date) }}</span>
                                    <span v-if="item.planning_intervention_prevision" class="text-xs" :class="{
                                    'text-success' : (item.duration === item.planning_intervention_prevision.duration),
                                    'text-warning' : (item.duration < item.planning_intervention_prevision.duration),
                                    'text-danger' : (item.duration > item.planning_intervention_prevision.duration)
                                }">
                                    {{ item.duration }} m / {{ item.planning_intervention_prevision.duration }} m
                                </span>
                                    <span class="text-xs" v-else>{{ item.duration }} m</span>
                                    <span>{{ item.technician.full_name }}</span>
                                </div>
                            </md-table-cell>
                            <md-table-cell md-label="Etat">
                                {{ item.status.name }}
                            </md-table-cell>
                            <md-table-cell md-label="Action">
                                <md-menu md-size="small" :md-offset-x="0" :md-offset-y="5">
                                    <md-button md-menu-trigger class="md-icon-button md-raised">
                                        <font-awesome-icon :icon="['fas', 'wrench']"></font-awesome-icon>
                                    </md-button>

                                    <md-menu-content>
                                        <div class="px-4">
                                            <p class="font-medium text-sm">Intervention - #{{ item.id }}</p>
                                            <div class="mt-1">
                                                <md-menu-item v-if="item.status_id >= 6 && item.report && item.report.url" class="md-item-default" @click="getLastVersion(item)">Voir le rapport PDF fixe</md-menu-item>
                                                <template v-if="canGeneratePdf(item)">
                                                    <md-menu-item v-if="item.status_id >= 6" class="md-item-default" @click="generatePdf(item, 'simple')">Voir le rapport PDF LIVE</md-menu-item>
                                                    <md-menu-item v-if="item.status_id >= 6 && item.canGeneratePdfWithPlans"
                                                                  class="md-item-default" @click="generatePdf(item, 'complete')">
                                                        Voir le rapport PDF LIVE (avec plans)
                                                    </md-menu-item>
                                                </template>
                                                <md-menu-item class="md-item-default" @mousedown="goToRoute($event, 'Intervention Details', {id: item.id})">Modifier</md-menu-item>
                                            </div>
                                        </div>
                                    </md-menu-content>
                                </md-menu>
                            </md-table-cell>
                            <md-table-cell md-label="Commentaire">
                                <div>{{ item.comment }}</div>
                                <div class="text-xs" v-if="item.planning_intervention_prevision && item.planning_intervention_prevision.commentable">
                                    PI : {{ item.planning_intervention_prevision.commentable.comment }}
                                </div>
                            </md-table-cell>
                        </md-table-row>
                    <md-table-row v-else-if="loading">
                        <md-table-cell>
                            <div class="calendar-overlay opacity-100 fixed z-50 w-full h-full">
                                <div class="h-full w-full flex items-center justify-center">
                                    <md-progress-spinner class="md-white" md-mode="indeterminate"
                                                         :md-diameter="30" :md-stroke="5"></md-progress-spinner>
                                </div>
                            </div>
                        </md-table-cell>
                    </md-table-row>
                    <md-table-empty-state
                        md-label="Pas d'interventions trouvées"
                        md-description="Essayez une recherche différente">
                    </md-table-empty-state>
                </md-table>
            </template>
        </md-card-content>
        <md-card-actions md-alignment="space-between"  v-if="this.interventions.length > 0">
            <p class="card-category">
                Affichage des éléments {{ from + 1 }} à {{ to }} sur {{ pagination.total }} éléments
            </p>
            <pagination
                class="pagination-no-border pagination-info"
                v-model="pagination.currentPage"
                :per-page="pagination.perPage"
                :total="pagination.total"
                @input="getInterventions"
            >
            </pagination>
        </md-card-actions>
    </div>
</template>

<script>
import { Pagination } from "@/components"
import routerMixin from '@/mixins/router-mixin'

export default {
    name: "DetailInterventionsTable",
    components: {
        Pagination
    },
    mixins: [ routerMixin ],
    props: {
        type: {
            type: String,
        },
        siteId: {
            type: Number,
            default() {
                return null
            }
        }
    },
    data() {
        return {
            interventions: [],
            technicians: [],
            pagination: {
                perPage: 10,
                currentPage: 1,
                perPageOptions: [10, 25, 50, 100],
                total: 0
            },
            searchQuery: "",
            propsToSearch: ["name"],
            searchedData: [],
            fuseSearch: null,
            loading: false,
            moduleDispatch: (this.type === 'site') ? 'sites/getSiteInterventions' : 'clients/getClientInterventions',
            id: this.siteId ? this.siteId : ((this.type === 'site') ? this.$route.params.idSite : this.$route.params.id)
        }
    },
    methods: {
        async generatePdf (item, type) {
            const { data } = await this.$store.dispatch('interventionReports/generatePdf', {
                id: item.id,
                type: type
            })
            let link = document.createElement('a')
            link.setAttribute('href', data)
            link.setAttribute('target', '_blank')
            link.click()
        },
        getLastVersion (item) {
            let link = document.createElement('a')
            link.setAttribute('href', item.report.url)
            link.setAttribute('target', '_blank')
            link.click()
        },
        async getInterventions() {
            if (this.searchQuery.length === 0 || this.searchQuery.length >= 2) {
                let lengthNb = this.searchQuery.length
                if (!this.loading) {
                    this.interventions = [{}]
                    this.loading = true
                }

                const response = await this.$store.dispatch(this.moduleDispatch, {
                    id: this.id,
                    page: this.pagination.currentPage,
                    perPage: this.pagination.perPage,
                    search: this.searchQuery
                })

                if (lengthNb === this.searchQuery.length) {
                    this.interventions = response.data.data
                    this.pagination.total = response.data.total
                    this.loading = false
                }
            }
        },
        getInterventionType(intervention) {
            if (intervention.category_id !== 3) {
                return intervention.category.name
            }
            if (intervention.contract_id) {
                return 'Ponctuel contrat'
            }
            return 'Ponctuel site'
        },
        getStartDate(date) {
            return this.$moment(date).format('DD/MM/YYYY')
        },
        getPlanificationDate(date) {
            return this.$moment(date).format('YYYYMM')
        },
        getStartTime(date) {
            return this.$moment(date).format('HH:mm')
        },
        goToContractDetail(e, item) {
            let contract = item.contract ? item.contract : (item.planning_intervention_prevision ? item.planning_intervention_prevision.planning_intervention_group.planning_intervention.contract : false)
            if (contract) {
                if (e.type === 'mouseup') {
                    let routeData = this.$router.resolve({name: 'Contract Details', params: { contractId: contract.id }});
                    window.open(routeData.href, '_blank');
                } else {
                    this.goToRoute(e,'Contract Details', { contractId: contract.id })
                }
            }
        },
        getContract (item) {
            return item.contract ? item.contract : (item.planning_intervention_prevision ? item.planning_intervention_prevision.planning_intervention_group.planning_intervention.contract : false)
        },
        canGeneratePdf(item) {
            // Check if pdf report can be generated (report exists in database, has a model value, model value is not from V1, and has a signature)
            return item.report && (item.report.model_value && JSON.parse(item.report.model_value).madate === undefined) && item.report.report_signature !== null
        },
    },
    computed: {
        queriedData() {
            let result = this.interventions;
            if (this.searchedData.length > 0) {
                result = this.searchedData;
            }
            return result.slice(this.from, this.to);
        },
        to() {
            let highBound = this.from + this.pagination.perPage;
            if (this.pagination.total < highBound) {
                highBound = this.pagination.total;
            }
            return highBound;
        },
        from() {
            return this.pagination.perPage * (this.pagination.currentPage - 1);
        },
        total() {
            return this.searchedData.length > 0
                ? this.searchedData.length
                : this.interventions.length;
        },
    },
    mounted() {
        this.getInterventions()
    },
}
</script>

<style lang="scss" scoped>
::v-deep {
    .md-table-head-container {
        text-align: center !important;
    }

    .calendar-overlay {
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;

        position: absolute !important;

        overflow: hidden;
        background: rgba(0, 0, 0, 0.35);
        transition: .35s cubic-bezier(.4,0,.2,1) !important;
        transition-property: opacity;
        will-change: opacity;

        .md-progress-spinner {
            &.md-white {
                circle {
                    stroke: #ffffff;
                }
            }
        }
    }
}
</style>
